"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityFromSchema = void 0;
const model_1 = require("../model");
const attributesFromSchema_1 = require("./attributesFromSchema");
function entityFromSchema(schema) {
    const { attributes, attributesContainerSchema, attributesContainerSchemaLocation } = (0, attributesFromSchema_1.attributesFromSchema)(schema);
    const entity = new model_1.Entity(schema, attributes, attributesContainerSchema, attributesContainerSchemaLocation);
    return entity;
}
exports.entityFromSchema = entityFromSchema;
